import _ from 'lodash';
import {
    MA_WEALTH,
    FA_WEALTH,
    FINANCIAL_ADVISER_ID,
    ACCOUNTANT_ID,
    LEGAL_ADVISER_ID,
    FINANCIAL_ADVISER_PENSION_TRANSFERS_SPECIALIST,
    FINANCIAL_ADVISER_PENSION_TRANSFERS_NON_SPECIALIST,
    FAKE_FINANCIAL_ADVISER_PENSION_TRANSFERS_DROPDOWN_ID,
} from '../__constants__';

import servicesFinancial from './services-financial-adviser';
import servicesAccountant from './services-accountant';
import servicesLegal from './services-legal-adviser';


const services = {
    [FINANCIAL_ADVISER_ID]: servicesFinancial.financial_adviser_services,
    [ACCOUNTANT_ID]: servicesAccountant.accountant_business_services,
    [LEGAL_ADVISER_ID]: servicesLegal.legal_adviser_services,
};

export function getDropdownOptions(services) {
    let options = [];

    _.forEach(services, function(set) {
        options.push({
            id: set.id,
            gka: set.gka,
            label: set.label,
            popularity: set.popularity,
        });
    });

    options.sort((a, b) => a.popularity - b.popularity);

    return options;
}

export function getDropdownOptionsByVertical(verticalId, shouldFilterTransfers = true) {
    const servicesList = _.cloneDeep(services[verticalId]);
    if (verticalId === FINANCIAL_ADVISER_ID) {
        servicesList[FAKE_FINANCIAL_ADVISER_PENSION_TRANSFERS_DROPDOWN_ID] = {
            id: FAKE_FINANCIAL_ADVISER_PENSION_TRANSFERS_DROPDOWN_ID,
            label: 'Pension Transfers',
            popularity: 5,
        };

        if (!shouldFilterTransfers) {
            return getDropdownOptions(servicesList)
        }

        return getDropdownOptions(servicesList).filter(({ gka }) =>
            gka !== FINANCIAL_ADVISER_PENSION_TRANSFERS_SPECIALIST &&
            gka !== FINANCIAL_ADVISER_PENSION_TRANSFERS_NON_SPECIALIST
        );
    }

    return getDropdownOptions(servicesList);
}

export function getChildDropdownOptions(services, parentList) {
    let options = [];

    _.forEach(parentList, function(parent) {
        const selectedParentObjects = _.find(services, function(parentObject) { return parentObject.id === parent});

        _.forEach(selectedParentObjects.children, function(child) {
            options.push({
                id: child.id,
                gka: child.gka,
                label: child.label
            });
        })
    });

    return options;
}

export function getServicesLabels(services, parentList) {
    let labels = '';
    _.forEach(parentList, function(parent, index) {
        const parentObject = _.find(services, function(parentObject) { return parentObject.id === parent});

        labels = labels + (labels ? ' & ' : '') + parentObject.label
    });

    return `${labels} Advice Areas`;
}

export function getWealthDropdownOptions(isMortgageAdviser) {
    if (isMortgageAdviser) {
        return [
            { id: MA_WEALTH.SHOW_ALL_LEVELS.ID, label: MA_WEALTH.SHOW_ALL_LEVELS.LABEL },
            { id: MA_WEALTH.ANY_LEVEL.ID, label: MA_WEALTH.ANY_LEVEL.LABEL },
            { id: MA_WEALTH.OVER_50000.ID, label: MA_WEALTH.OVER_50000.LABEL },
            { id: MA_WEALTH.OVER_100000.ID, label: MA_WEALTH.OVER_100000.LABEL },
            { id: MA_WEALTH.OVER_250000.ID, label: MA_WEALTH.OVER_250000.LABEL },
            { id: MA_WEALTH.OVER_500000.ID, label: MA_WEALTH.OVER_500000.LABEL },
        ];
    } else {
        return [
            { id: FA_WEALTH.SHOW_ALL_LEVELS.ID, label: FA_WEALTH.SHOW_ALL_LEVELS.LABEL },
            { id: FA_WEALTH.UNDER_50000.ID, label: FA_WEALTH.UNDER_50000.LABEL },
            { id: FA_WEALTH.OVER_50000.ID, label: FA_WEALTH.OVER_50000.LABEL },
            { id: FA_WEALTH.OVER_100000.ID, label: FA_WEALTH.OVER_100000.LABEL },
            { id: FA_WEALTH.OVER_250000.ID, label: FA_WEALTH.OVER_250000.LABEL },
            { id: FA_WEALTH.OVER_500000.ID, label: FA_WEALTH.OVER_500000.LABEL },
        ];
    }
}
